module.exports = __webpack_public_path__ + "static/media/strip-rocketeer-desk.ee3fed62.svg";